import Select from 'react-select'
import Label from './Label';
import Input from './Input';

const IsRequiredField = ({isRequired, value, isSubmitted}) => {
    return(
      <>
        {isRequired&&!value&&isSubmitted&&<span className="block text-xs text-red-500"> This field is required </span>}
      </>
    )
}

const FirstName = ({value, onChange}) => {

    return (
        <div>
            <Label>Firstname</Label>
            <Input 
                type="text" 
                required
                value={value}
                onChange={onChange}
            />
        </div>
    )
  
}

const LastName = ({value, onChange}) => {

    return (
        <div>
            <Label>Lastname</Label>
            <Input 
                type="text" 
                required
                value={value}
                onChange={onChange}
            />
        </div>
    )
}
const Email = ({value, onChange}) => {

    return (
        <div>
            <Label>Email</Label>
            <Input 
                type="email" 
                disabled={true}
                className="cursor-not-allowed bg-gray-100"
                value={value}
            />
        </div>
    )
}

const Phone = ({value, onChange}) => {

    return (
        <div>
            <Label>Phone</Label>
            <Input 
                type="number" 
                value={value}
                onChange={onChange}
            />
        </div>
    )
}
const Country = ({onChange, defaultValue, options}) => {

    return (
        <div>
            <Label>Country</Label>
            <Select
                onChange={onChange}
                value={defaultValue&&{countries: defaultValue, countries: defaultValue}}
                defaultValue={defaultValue&&{countries: defaultValue, countries: defaultValue}}
                getOptionLabel={option =>`${option.countries}`}
                getOptionValue={option =>`${option.countries}`}
                placeholder="Select country..."
                options={options}
            /> 
        </div>
    )
  
}

// Password action
const OldPassword = ({showPwd, value, onChange, isSubmitted, isRequired=false}) => {

    return (
        <div>
            <Label isRequired={isRequired}>Old password</Label>
            <Input 
                type={showPwd? 'text':'password'} 
                required
                value={value}
                onChange={onChange}
            />
            <IsRequiredField 
                value={value} 
                isRequired={isRequired} 
                isSubmitted={isSubmitted} 
            />
        </div>
    )
  
}
const NewPassword = ({showPwd, value, onChange, isSubmitted, isRequired=false}) => {

    return (
        <div>
            <Label isRequired={isRequired}>New Password</Label>
            <Input 
                type={showPwd? 'text':'password'} 
                required
                value={value}
                onChange={onChange}
            />
            <IsRequiredField 
                value={value} 
                isRequired={isRequired} 
                isSubmitted={isSubmitted} 
            />
        </div>
    )
  
}
const ConfirmNewPassword = ({showPwd, value, onChange, isSubmitted, isRequired=false}) => {

    return (
        <div>
            <Label isRequired={isRequired}>Confirm new password</Label>
            <Input 
                type={showPwd? 'text':'password'} 
                required
                value={value}
                onChange={onChange}
            />
            <IsRequiredField 
                value={value} 
                isRequired={isRequired} 
                isSubmitted={isSubmitted} 
            />
        </div>
    )
  
}

export {
    FirstName,
    LastName,
    Phone,
    Email,
    Country,
    OldPassword,
    NewPassword,
    ConfirmNewPassword
}
